import React from 'react';
/**
 * 空历史card
 */
const CrossEmptyList = React.memo((props) => {
  return (
    <div
      className="cross-empty-list-fa"
      style={{
        width: '100%',
        height: 456,
        borderRadius: 12,
      }}
    >
      <div className="h1" style={{ textAlign: 'center' }}>
        <img
          src="//img30.360buyimg.com/pop/jfs/t1/5299/25/18966/64164/637736b3E124c3a04/9695e43de6ee5c3f.png"
          style={{ width: 308, height: 138 }}
        />
      </div>
      <div
        className="h2"
        style={{
          fontWeight: 400,
          fontSize: 16,
          textAlign: 'center',
          color: 'rgba(0, 0, 0, 0.82)',
        }}
      >
        暂无查询记录
      </div>
      <div
        className="h3"
        style={{
          fontWeight: 400,
          fontSize: 14,
          textAlign: 'center',
          color: 'rgba(0, 0, 0, 0.45)',
          paddingTop: 4,
          paddingBottom: 16,
        }}
      >
        选择”你的品类&商品类型”，即可找到适合你的跨品类合作~
      </div>
      <div className="h4" style={{ textAlign: 'center' }}>
        <img
          src="//img30.360buyimg.com/pop/jfs/t1/75590/20/22667/67415/637b211bE2fa26620/ede1283ebb7807df.png"
          style={{ width: 695, height: 324 }}
        />
      </div>
    </div>
  );
});

export default CrossEmptyList;
